/** The payment sheet: amounts, methods, notes, UPI and split payments. */
export default {
  'pay.title': 'Collect payment',
  'pay.subtitleLines': { one: '{count} line', other: '{count} lines' },
  'pay.subtitlePayments': '{count} payments',
  'pay.amountDue': 'Amount due',
  'pay.complete': 'Complete sale',
  'pay.completeAmount': 'Complete sale · ₹{amount}',
  'pay.saving': 'Saving…',
  'pay.cancel': 'Back to bill',
  'pay.keysHint': 'completes the sale',
  'pay.escHint': 'goes back to the bill',
  'pay.noTax': 'No Tax: −₹{amount}',
  'pay.inclTax': 'incl. ₹{amount} {tax}',
  'pay.customerSaves': 'Customer saves ₹{amount}',
  'pay.received': 'Received',
  'pay.remaining': 'Remaining to pay',
  'pay.giveBack': 'Give back',
  'pay.fullyPaid': 'Fully paid',
  'pay.handBack': 'Hand back:',
  'pay.payments': 'Payments',
  'pay.payment': 'Payment {number}',
  'pay.removePayment': 'Remove payment {number}',
  'pay.methodFor': 'Payment method for payment {number}',
  'pay.upiQr': 'UPI QR for ₹{amount}',
  'pay.upiNote': 'Bill at {store}',
  'pay.scanAsk': 'Ask the customer to scan',
  'pay.scanHint': 'Any UPI app works. ₹{amount} is already in the code, so nobody types the amount.',
  'pay.pays': 'Pays',
  'pay.noUpi': 'Add the store’s UPI ID in Admin → Settings (payments.upi_vpa) to show a pay-by-QR code here.',
  'pay.cashReceived': 'Cash received (₹)',
  'pay.methodAmount': '{method} amount (₹)',
  'pay.upiRef': 'UPI reference / UTR',
  'pay.cardRef': 'Card slip / approval no.',
  'pay.otherRef': 'Reference (optional)',
  'pay.upiRefPlaceholder': '12 digits from the customer’s app',
  'pay.notes': 'Notes: {notes}',
  'pay.tapNotes': 'Tap the notes handed over',
  'pay.exact': 'Exact',
  'pay.clear': 'Clear',
  'pay.notesGroup': 'Notes handed over',
  'pay.addNote': 'Add a ₹{rupee} note',
  'pay.addNoteCount': 'Add a ₹{rupee} note ({count} so far)',
  'pay.split': 'Split payment',
  'pay.stillToCollect': '{amount} still to collect.',

  // lib/payments: problems shown beside a payment row
  'pay.issue.amount': 'Enter a valid amount.',
  'pay.issue.upiRef': 'UPI needs the UTR / transaction reference.',
  'pay.issue.cardRef': 'Card needs the slip or approval reference.',
  'pay.issue.overExact': 'UPI, card and other amounts must be exact. Together they exceed the bill.',
  'pay.issue.nothing': 'Enter the amount received.',
  'pay.issue.short': 'The bill is not fully paid yet.',

  // change to hand back, and short-dated stock (lib/till)
  'change.note': 'note',
  'change.coin': 'coin',
  'change.face': '₹{value} {kind}',
  'change.many': '{count} × {face}',
  'change.paise': '{value} paise',
  'expiry.expired': { one: 'Expired {count} day ago', other: 'Expired {count} days ago' },
  'expiry.today': 'Expires today',
  'expiry.in': { one: 'Expires in {count} day', other: 'Expires in {count} days' },
  'visit.today': 'today',
  'visit.yesterday': 'yesterday',
  'visit.daysAgo': '{count} days ago',
} as const;